import { useRouter } from 'next/router'
import useAuth from 'hooks/useAuth'
import trackEvent from '~/trackers'

const CREATE_EVENT_URL = '/event/create'

// Event is the only product type left to create — Digital Content was
// retired (TIP-21825) — so every "create product" entry point goes straight
// here instead of through the old picker popup. Fires the same
// click_create_event payload the popup fired once "Create Event" was chosen,
// so existing Mixpanel funnels keep working across the collapsed step.
export default function useCreateEventRedirect() {
  const { push, pathname, query } = useRouter()
  const { user } = useAuth()

  return () => {
    trackEvent.content(
      'click_create_event',
      { pathname, query, user },
      { modal_name: 'CREATE_PRODUCT' },
    )
    push(
      `${CREATE_EVENT_URL}?source=${pathname}&source_action=click_create_event`,
    )
  }
}
